import React from 'react'

export default function SummarySkeleton() {
  return (
    <div className="flex flex-col animate-pulse space-y-5 mt-4 p-4">
      <div className="flex">
        <div className="flex-1">
          <div className="w-8 sm:w-32 h-5 bg-gray-200 dark:bg-zinc-600 rounded"></div>
        </div>
        <div className="w-12 h-5 dark:bg-zinc-600 bg-gray-200 rounded"></div>
      </div>
      <div className="flex">
        <div className="flex-1">
          <div className="w-8 sm:w-32 h-5 dark:bg-zinc-600 bg-gray-200 rounded"></div>
        </div>
        <div className="w-12 h-5 dark:bg-zinc-600 bg-gray-200 rounded"></div>
      </div>
      <div className="flex">
        <div className="flex-1">
          <div className="w-8 sm:w-32 h-5 dark:bg-zinc-600 bg-gray-200 rounded"></div>
        </div>
        <div className="w-12 h-5 dark:bg-zinc-600 bg-gray-200 rounded"></div>
      </div>
      <div className="flex">
        <div className="flex-1">
          <div className="w-8 sm:w-32 h-7 dark:bg-zinc-600 bg-gray-200 rounded"></div>
        </div>
        <div className="w-12 h-7 dark:bg-zinc-600 bg-gray-200 rounded"></div>
      </div>
    </div>
  )
}
